class Title {
    constructor(name) {
        this.name = name;
    }
}   

const titles = [
    new Title('MR'),
    new Title('MRS'),
    new Title('MISS')
];  

export { Title, titles };